<div class="creator">
  <ng-container *ngIf="avatarStates.length > 0">
    <div style="display: flex">
      <avatar
        *ngFor="let avatarState of avatarStates"
        class="creator-avatar"
        [avatarState]="avatarState | async"
      ></avatar>
      <div truncate class="creator-name">
        {{ namesStr }}
      </div>
    </div>
  </ng-container>
</div>
